module.exports = {
  FILTERS: {
    ALL: 'all',
    NOTSEEN: 'notSeen',
    NOTDOWNLOADED: 'notDownloaded',
    NOUSERS: 'noUsers',
    WITHATTACHMENTS: 'withNoAttachments',
    WITHNOATTACHMENTS: '',
  },
  STATUS: {
    MISSING_USERS: 'No hay usuarios',
    MISSING_MATERIALS: 'No hay adjuntos',
    NOT_SEEN: 'No Procesada',
    SEEN_BY_ALL: 'Procesada'
  }
};